/* eslint-disable no-undef */
// TODO: remove code above and fix issues in case changing this file

'use strict';
(function () {
	angular.module('dat.shared-components.common')
		.directive('datSlider', datSlider);

	datSlider.$inject = ['$log', 'eventNameService'];

	var $log, eventNameService;
	function datSlider(_$log_, _eventNameService_) {
		$log = _$log_; eventNameService = _eventNameService_;

		return {
			scope: {
				values: '@',
				startingValue: '@',
				axisOrient: '@',
				changedToValue: '&',
				disableSlider: '='
			},
			template: '<div></div>',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope, elem, attrs) {
		if (!scope.values) {
			logAndThrowError('Missing \'values\' attribute for datSlider directive');
		}

		var valuesArray = scope.$eval(scope.values);

		if (!valuesArray || !_.isArray(valuesArray) || valuesArray.length == 0) {
			logAndThrowError('Missing or invalid \'values\' attribute for datSlider directive');
		}
		if (!scope.startingValue) scope.startingValue = valuesArray[0];
		if (!scope.axisOrient) {
			scope.axisOrient = 'top';
		}
		else {
			if (scope.axisOrient !== 'top' && scope.axisOrient != 'bottom') {
				logAndThrowError('axisOrient attribute for datSlider directive must be either \'top\' or \'bottom\'');
			}
		}
		var slider = d3dat.slider()
			.axisOrient(scope.axisOrient)
			.sliderValues(valuesArray)
			.log($log)
			.value(scope.startingValue)
			.on('slideend', sliderEventSlideEnd)
			.on('click', sliderEventClick);

		if (scope.disableSlider) {
			slider.disable(scope.disableSlider.disable);
		}

		d3.select(elem[0]).call(slider);

		scope.$watch('disableSlider', function (value, previous) {
			$log.debug('datSlider: disableSlider changed. value: ' + (value ? value.disable : '') + '. previous: ' + (previous ? previous.disable : ''));
			if (value && (value !== previous || value !== slider.disable())) {
				slider.disable(value.disable);
			}
		}, true);

		scope.$on(eventNameService.slider.newValue, onNewValue);

		///////////////////////////////////////////////////

		function sliderEventSlideEnd(evt, value) {
			$log.debug('slider slideend: ' + value);
			sliderEventNotification(value);
		}

		function sliderEventClick(evt, value) {
			$log.debug('slider click: ' + value);
			sliderEventNotification(value);
		}

		function sliderEventNotification(value) {
			if (scope.changedToValue) {
				scope.changedToValue({ value: value });
			}
		}

		function onNewValue(event, sliderId, value){
			if (sliderId === attrs.id){
				slider.value(value);
			}
		}
	}

	function logAndThrowError(errorMsg) {
		$log.error(errorMsg);
		throw errorMsg;
	}
})();
